
import React from 'react';
import { MIME_TYPE } from '../../constants/constants';
import FormFw from '../../framework/form/FormFw';
import { BasePage } from '../../framework/pages/BasePage';

export class DocumentPreview extends BasePage {

    createPageProperties = (pageApi) => {
        return {
            title: '',
        };
    }
    
    renderPage(pageApi) {
        let str = pageApi.name.type_file;
        let res = str.split("/");
        let type_file = res[1];
        let ruta_file = pageApi.name.url;

        if(type_file == 'vnd.openxmlformats-officedocument.wordprocessingml.document'){
            type_file = 'docx';
        }

        if(type_file == 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
            type_file = 'xlsx';
        }

        let formConfig = { };

        if(type_file == 'pdf'){
            formConfig = {
                fields:[
                    { type: 'object', data: ruta_file, data_type: MIME_TYPE.pdf},
                ],
            };
        }
        else { 
            formConfig = {
                layout: "vertical",
                fields:[
                    { type: 'preview', type_file, ruta_file},
                ],
            };
        }

        return (
            <>
                <FormFw 
                    name="previewForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />

            </>
        )

    }
    
}